var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"test-cat-claim-btn",attrs:{"block":_vm.block,"color":_vm.color,"text":_vm.text,"loading":_vm.loading,"small":""},on:{"click":_vm.claim}},[_vm._v(" Claim ")])}
var staticRenderFns = []

export { render, staticRenderFns }